import React from "react";

const CouponBox = ({ coupon, icon, onClick }) => {

  return (
    <div 
      className="coupon-box"
      onClick={onClick}
    >
      <div 
        className="coupon-image-container" 
      >
        <img 
          src={coupon.coverImageUrl} 
          className="coupon-image"
        />
      </div>
      <div className="coupon-info">
        <div>{coupon.title}</div>
        <div className="coupon-info-points">{`${coupon.points} Punkte`}</div>
      </div>
      <div className="coupon-status">
        <img src={icon} alt="Done" />
      </div>
    </div>
  );
};

export default CouponBox;